import React from "react";
import { useTable } from "../../Components/useTable";

const AssignedUsers = () => {
  const type = "Assign Livestream Tag";
  const headCells = [
    { id: "code", numeric: false, label: "RID" },
    { id: "assignUsername", numeric: false, label: "User Name" },
    { id: "assignUserImage", numeric: false, label: "User Image" },
    { id: "adminName", numeric: false, label: "Admin Name" },
    { id: "adminImage", numeric: false, label: "Admin Image" },
    { id: "tagName", numeric: false, label: "Tag Name" },
    { id: "tagImage", numeric: false, label: "Tag Image" },
    { id: "expiredAt", numeric: false, label: "Expired" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default AssignedUsers;
